import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { RadioButtonGroup } from '@els/els-react--radio-button';
import { StructureEditorType } from '@Containers/StructureEditor/constants';

import './EditorSwitcher.scss';

function EditorSwitcher({ editorType, onChange, isLoading }) {
  return (
    <div className={cn('retro-synthesis-editor-switcher')}>
      <svg className="retro-synthesis-editor-switcher--icon">
        <use xlinkHref="#icon-eraser" />
      </svg>
      <span className="retro-synthesis-editor-switcher--text">Structure editor selected:</span>
      <RadioButtonGroup.Option
        className="retro-synthesis-editor-switcher--radio-buttons"
        onChange={() => editorType !== StructureEditorType.MARVIN && onChange(StructureEditorType.MARVIN)}
        checked={editorType === StructureEditorType.MARVIN}
        label="MarvinJS"
      />
      <RadioButtonGroup.Option
        className="retro-synthesis-editor-switcher--radio-buttons"
        onChange={() => editorType !== StructureEditorType.CHEMDRAW && onChange(StructureEditorType.CHEMDRAW)}
        checked={editorType === StructureEditorType.CHEMDRAW}
        label="ChemDrawJS"
      />
    </div>
  );
}

EditorSwitcher.defaultProps = {
  onChange: () => null,
  isLoading: false,
};

EditorSwitcher.propTypes = {
  editorType: PropTypes.oneOf(StructureEditorType.allTypes),
  onChange: PropTypes.func,
  isLoading: PropTypes.bool,
};

export default EditorSwitcher;
